import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { current: String }
  static targets = ["datePicker", "fromDate", "toDate"]

  select(event) {
    const period = event.currentTarget.dataset.period
    const url = new URL(window.location.href)
    url.searchParams.set('period', period)

    // Remove custom date params when switching to preset periods
    url.searchParams.delete('from_date')
    url.searchParams.delete('to_date')

    window.location.href = url.toString()
  }

  toggleCustom(event) {
    if (this.hasDatePickerTarget) {
      const isOpening = this.datePickerTarget.classList.contains("hidden")
      this.datePickerTarget.classList.toggle("hidden")

      // Highlight Custom button when opening date picker
      if (isOpening) {
        const customBtn = event.currentTarget

        // Remove active styles from all period buttons
        const allButtons = this.element.querySelectorAll('button[data-period]')
        allButtons.forEach(btn => {
          btn.classList.remove('text-white', 'bg-gray-900', 'font-semibold', 'shadow-sm')
          btn.classList.add('text-gray-600')
        })

        // Add active styles to Custom button
        customBtn.classList.remove('text-gray-600')
        customBtn.classList.add('text-white', 'bg-gray-900', 'font-semibold', 'shadow-sm')
      }
    }
  }

  applyCustom() {
    const from = this.hasFromDateTarget ? this.fromDateTarget.value : null
    const to = this.hasToDateTarget ? this.toDateTarget.value : null

    if (from && to) {
      const url = new URL(window.location.href)
      url.searchParams.set('period', 'custom')
      url.searchParams.set('from_date', from)
      url.searchParams.set('to_date', to)
      window.location.href = url.toString()
    }
  }
}
